var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Controls"},[_vm._v(" "+_vm._s(_vm.data[parseInt(_vm.value.value)|| 3])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }